import React, { useState } from "react";
import CustomModal from "../modal/Modal";
import { useDispatch } from "react-redux";
import * as contentActions from "../../../redux/content/ContentActions";
import { useNavigate } from "react-router-dom";

function HelpSection({ showModal, setShowModal, selectedSection, setSelectedSection }: any) {
  const [pageName, setPageName] = useState("");
  const [arabicPageName, setArabicPageName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const handleShowModal = () => {
    setShowModal(true);
  };

  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const onSave = () => {
    let dataToSend = {
      sectionName: sectionName,
      pageName: pageName,
      arabicPageName: arabicPageName,
      link: "",
    };
    dispatch(contentActions.createHelpContent(dataToSend, navigate));
  };

  let options = [
    {
      label: "Registration & Login",
      value: "register&Login",
    },
    {
      label: "Items",
      value: "items",
    },
    {
      label: "Sale",
      value: "sale",
    },
    {
      label: "Invoices",
      value: "invoices",
    },
    {
      label: "Customer",
      value: "customer",
    },
    {
      label: "Reports",
      value: "reports",
    },
    {
      label: "Company",
      value: "company",
    },
    {
      label: "Settings",
      value: "settings",
    },
  ];
  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="d-flex justify-content-center align-items-center modal-body-page">
        <select
          className="w-100 py-2 border-0 "
          style={{ background: "#F2F2F2", fontWeight: 700, color: selectedSection?.length > 0 ? "#404040" : " #8c8c8c", minWidth: "250px" }}
          onChange={(e) => {
            setSelectedSection(e?.target?.value);
          }}
          value={selectedSection}
        >
          {/* <option value="" disabled hidden style={{ color: "#8c8c8c !important" }}> */}
          <option value="">All Sections</option>
          {options?.map((item, index) => {
            return (
              <option key={index} value={item?.label} style={{ color: "#333333", fontWeight: 500, fontSize: 14 }}>
                {item?.label}
              </option>
            );
          })}
        </select>
      </div>
      <div className="new-page-text" style={{ marginLeft: "8rem", whiteSpace: "nowrap" }} onClick={handleShowModal}>
        NEW PAGE
      </div>
      <div>
        <CustomModal
          isOpen={showModal}
          toggle={() => {
            setShowModal(!showModal);
            setPageName("");
            setArabicPageName("");
            setSectionName("");
          }}
          cancelText="CANCEL"
          confirmText="SAVE"
          onSave={onSave}
          title="Page details"
          isTitleCentered={false}
          disabledBtn={pageName?.length === 0 || sectionName?.length === 0 || arabicPageName?.length === 0}
          children={
            <>
              <div className="d-flex justify-content-center w-100  align-items-center modal-body-page">
                <select
                  className="w-100  border-0 "
                  style={{
                    background: "#F2F2F2",
                    fontWeight: 700,
                    color: sectionName?.length > 0 ? "#404040" : " #8c8c8c",
                    paddingTop: ".7rem",
                    paddingBottom: ".7rem",
                  }}
                  onChange={(e) => {
                    setSectionName(e?.target?.value);
                  }}
                  value={sectionName}
                >
                  {/* <option value="" disabled hidden style={{ color: "#8c8c8c !important" }}> */}
                  <option value="" disabled hidden>
                    Select Section
                  </option>
                  {options?.map((item, index) => {
                    return (
                      <option key={index} value={item?.label} style={{ color: "#333333", fontWeight: 500, fontSize: 14 }}>
                        {item?.label}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="mt-2 modal-body-page"style={{ paddingTop: "1rem" }}>
                <input
                  type="text"
                  className="w-50 short-select-field"
                  placeholder="Enter english page name"
                  value={pageName}
                  onChange={(e) => setPageName(e?.target?.value)}
                  style={{ background: "#F2F2F2", paddingBottom: ".3rem", minHeight: "40px" }}
                />
              </div>
              <div className="mt-2 modal-body-page" style={{ paddingTop: "1rem" }}>
                <input
                  type="text"
                  className="w-50 short-select-field"
                  placeholder="Enter arabic page name"
                  value={arabicPageName}
                  onChange={(e) => setArabicPageName(e?.target?.value)}
                  style={{ background: "#F2F2F2", minHeight: "40px", paddingBottom: ".3rem" }}
                />
              </div>
            </>
          }
        />
      </div>
    </div>
  );
}

export default HelpSection;
